export const Abstract06Icon = () => {
  return (
    <svg
      width="125"
      height="124"
      viewBox="0 0 125 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M124.398 47.0673L94.2308 49.0146L117.078 29.0077L95.6782 7.58325L75.7365 30.3036L77.7273 2.28882e-05H47.4461L49.4118 29.9201L29.6451 7.19036L8.14738 28.5167L30.7993 48.5362L0.502668 46.4411L0.398438 76.7223L30.5705 74.8442L7.67754 94.7985L29.0283 116.272L49.0221 93.5975L46.9616 123.897L77.2433 123.966L75.3301 93.7958L95.3109 116.666L116.76 95.2907L94.0627 75.323L124.364 77.3485L124.398 47.0673Z"
        fill="url(#paint0_linear_1866_18403)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_18403"
          x1="62.3984"
          y1="2.28882e-05"
          x2="62.3984"
          y2="123.966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
};
